import React from 'react';
import { BoxImage, CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-navy px-3 py-4 text-center sm:px-6" data-id="element-49" data-mp="3ucx67lwhbz2d">
      <div className="mx-auto max-w-xl" data-id="element-50" data-mp="3uei3hja6hw3x">
        <h2 className="text-[1.1rem] font-extrabold uppercase leading-tight text-white sm:text-[1.7rem]" data-id="element-51" data-mp="c70yncel7jpm">
          One last question
        </h2>
        <p className="mt-1 text-[0.78rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-52" data-mp="83w01kxmo269">
          When another ultrasound image appears... Do you immediately know what
          you're looking at and where to start? Stop jumping between scattered
          resources and trying to understand ultrasound from text alone.
          Position the probe. Identify the landmarks. Follow the visual
          references.
        </p>
        <p className="mt-1 text-[0.72rem] font-extrabold uppercase tracking-wide text-gold sm:text-[0.86rem]" data-id="element-53" data-mp="14vg16zgj89k2">
          Scan. Compare. Recognize.
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[230px] sm:max-w-[280px]" data-id="element-54" data-mp="zxxwxmdgmiie" />

        <p className="mt-2 font-heading text-[1.05rem] font-extrabold uppercase text-white sm:text-[1.5rem]" data-id="element-55" data-mp="2c5pwtv1z1c26">
          🩻 ULTRASOUND VISUAL ATLAS™
        </p>
        <p className="mt-0.5 text-[0.68rem] font-bold uppercase tracking-wide text-white/80 sm:text-[0.8rem]" data-id="element-56" data-mp="2m2ub78pks38f">
          The Complete Visual Study System for Ultrasound Students
        </p>
        <p className="mt-0.5 text-[0.64rem] font-bold uppercase tracking-[0.14em] text-cyan sm:text-[0.74rem]" data-id="element-57" data-mp="2qzks1y97f2uw">
          Orient • Scan • Understand • Compare • Identify • Recognize
        </p>

        <div className="mx-auto mt-2 max-w-md" data-id="element-58" data-mp="30095aqqrwz6q">
          <p className="text-[0.76rem] font-extrabold uppercase tracking-wide text-gold sm:text-[0.9rem]" data-id="element-59" data-mp="34uddfdbrzd9e">
            🔥 GET THE COMPLETE SYSTEM TODAY
          </p>
          <div className="mt-1.5" data-id="element-60" data-mp="3errrx7e51rz2">
            <CTAButton label="⚡ GET ULTRASOUND VISUAL ATLAS™" data-id="element-61" data-mp="3esjfpw1hules" />
          </div>
          <p className="mt-1.5 text-[0.62rem] font-bold uppercase tracking-wide text-white/75 sm:text-xs" data-id="element-62" data-mp="3isld3t074so9">
            Immediate Access • Digital Delivery 🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}